import React from 'react'
import {Link} from "react-router-dom"

const HomePage = ()=>{
    return (
      <div className="page">
        <h1>Home Page</h1>
      </div>
    );
}

export default HomePage;